import styled from "styled-components";
import { TAB_BAR_HEIGHT_PX } from "../MobileNav/MobileNavStyled";

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: fit-content;
  width: 100%;
  background: #f3f4f7;
  gap: 5px;
`;
export const ContentLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  gap: 8px;
`;
export const SidebarContainer = styled.div`
  width: 72px;
  min-width: 66px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background-color: #fff;
  height: 100vh;
  border-radius: 0 8.5px 8.5px 0;
`;

export const ContentLayout = styled.div`
  flex: 1;
  min-width: 0;
  // overflow-y: auto;
  background: #f3f4f7;
  border-top-left-radius: 9px;
  margin-left: 80px;
  height: 100vh;
  
  @media (max-width: 768px) {
    margin-left: 0;
    border-radius: 0;
  }
`;

// ---------------------------------------------------------------------------
// Mobile shell (Mobile DMS v1, Phase 1)
// ---------------------------------------------------------------------------

/**
 * Full-viewport column: page content on top, fixed bottom tab bar
 * below. `100dvh` tracks mobile browsers' collapsing URL bar so the
 * tab bar never sits under browser chrome; the `100vh` line is the
 * fallback for engines without dynamic viewport units.
 */
export const MobileLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: #f3f4f7;
  overflow: hidden;
`;

export const MobilePageContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(
    ${TAB_BAR_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px)
  );
  box-sizing: border-box;
`;
